import { msg } from '@lingui/macro'

import * as React from 'react'

import { useTrans } from '~logic/i18n/useTrans'
import { CartSummaryMobile as UICartSummary } from '~ui/components/cart/CartSummaryMobile'

import { useCartContentCtx } from '../contexts/CartContentProvider'
import { getCartSum } from '../helpers/getCartSum'

type TBaseProps = PropsOf<typeof UICartSummary>

type TCartSummaryMobileProps = Omit<
  TBaseProps,
  'onBackClick' | 'onCartButtonClick' | 'backLabel' | 'cartSum' | 'cartItemCount' | 'dataTestId'
>

type TProps = NoChildren &
  TCartSummaryMobileProps & {
    onBackClick: TBaseProps['onBackClick']
    onCartButtonClick: TBaseProps['onCartButtonClick']
  }

/**
 * Mobile screen cart summary that uses cart sum and item count from CartContentProvider.
 */
export const CartSummaryMobile: React.FC<TProps> = ({
  onBackClick,
  onCartButtonClick,
  ...baseProps
}) => {
  const { trans } = useTrans()
  const cartContent = useCartContentCtx()
  const cartItemCount = cartContent?.itemCount

  return (
    <UICartSummary
      {...baseProps}
      backLabel={trans(msg`Back`)}
      cartSum={getCartSum(cartContent)}
      cartItemCount={cartItemCount}
      onBackClick={onBackClick}
      onCartButtonClick={onCartButtonClick}
    />
  )
}
